<button class="d-none d-md-flex delete-row-desktop" (click)="deleteRow.emit()" type="button" tabindex="-1">
  <fa-icon [icon]="['fas', 'trash']"></fa-icon>
</button>
<pl-confirm-button [i18nBaseKey]="'blocks.Block::Input::DataSetInput.delete'"
                   (confirm)="deleteRow.emit()"
                   confirmButtonClasses="btn-danger"
                   class="d-block d-md-none">
  <button class="btn btn-light btn-sm btn-block text-muted delete-row-mobile" type="button" tabindex="-1">
    <fa-icon [icon]="['fas', 'trash']"></fa-icon>
  </button>
</pl-confirm-button>
